import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Modal, Button, Table } from "semantic-ui-react";
// import { getDiscosuresByType } from "../common/Disclosures";

class GlbUse extends Component {
  // constructor(props) {
  //   super(props);
  //   const disclosures = getDiscosuresByType(
  //     "glb",
  //     this.props.user.userid,
  //     localStorage.getItem("mastType"),
  //     localStorage.getItem("mastState")
  //   );
  //   this.state={
  //     disclosures
  //   }
  // }

  componentDidMount() {}

  render() {
    const rows = [];
    // getDiscosuresByType(
    //   "glb",
    //   this.props.user.userid,
    //   localStorage.getItem("mastType"),
    //   localStorage.getItem("mastState"),
    //   rows
    // );
    // const discs = getDiscosuresByType(
    //   "glb",
    //   this.props.user.userid,
    //   localStorage.getItem("mastType"),
    //   localStorage.getItem("mastState")
    // );
    // console.log("s", discs);
    _.forEach(this.props.glbs, (disclosure, index) => {
      rows.push(
        <Table.Row key={`disc_${index}`}>
          <Table.Cell>{disclosure.text}</Table.Cell>
          <Table.Cell>{disclosure.disc}</Table.Cell>
        </Table.Row>
      );
    });

    return (
      <Modal
        style={{
          width: "50%",
          marginLeft: "25%",
          marginTop: "20px",
          marginBottom: "20px",
          position: "relative",
        }}
        // trigger={
        //   // <Button primary={false} onClick={() => this.props.openGlbDialog()}>
        //   //   GLB Use(*)
        //   // </Button>
        //   <div
        //     role={"button"}
        //     tabIndex={-1}
        //     onClick={() => this.props.openGlbDialog()}
        //   >
        //     GLB Use(*)
        //   </div>
        // }
        closeIcon
        open={this.props.active}
        onClose={() => this.props.closeGlbDialog()}
      >
        <Modal.Header>GLB Use</Modal.Header>
        <Modal.Content image scrolling>
          <Modal.Description className={"width-50-percent"}>
            <Table className={"table-border-all"}>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>Name</Table.Cell>
                  <Table.Cell>Description</Table.Cell>
                </Table.Row>
                {rows}
              </Table.Body>
            </Table>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions className={"dialog-actions"}>
          <Button
            className={"no-background-color float-right"}
            onClick={() => this.props.closeGlbDialog()}
          >
            Done
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

export default connect(
  mapStateToProps,
  null
)(GlbUse);



// WEBPACK FOOTER //
// ./src/components/dialogs/GlbUse.js